/* eslint-disable no-console */
const Logger = {
    logError(error, errorInfo) {
      console.log(error, errorInfo);
    },
    logInfo(message) {
      console.log(message);
    },
  };
  
  export default Logger;